import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=7feccdc8&scoped=true&"
import script from "./Topics.vue?vue&type=script&lang=js&"
export * from "./Topics.vue?vue&type=script&lang=js&"
import style0 from "./Topics.vue?vue&type=style&index=0&id=7feccdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feccdc8",
  null
  
)

export default component.exports